import React from 'react';
import { LabelField } from '../../components/Admin';

export default class Contact extends React.Component {
	render(){
		var { website, onChangeProp } = this.props;
		return (
			<div>
				<LabelField defaultValue={website.contactTitle} onChange={onChangeProp} prop="contactTitle" name="Título" info="40 caracteres" />
				<LabelField defaultValue={website.contactText} onChange={onChangeProp} prop="contactText" name="Texto" info="1024 caracteres" rows={3} />
				<LabelField defaultValue={website.phone} onChange={onChangeProp} prop="phone" name="Teléfono" rows={1} />
				<LabelField defaultValue={website.email} onChange={onChangeProp} prop="email" name="Email" rows={1} />
				<LabelField defaultValue={website.address} onChange={onChangeProp} prop="address" name="Ubicación" rows={2} />
			</div>
		)
	}
}
